import React, { createContext, useContext, useEffect, useState } from 'react';

type LoadingContextType = {
  loading: boolean;
  show: () => void;
  hide: () => void;
};

const LoadingContext = createContext<LoadingContextType>({
  loading: false,
  show: () => {},
  hide: () => {},
});

const useLoadingContext = () => {
  return useContext(LoadingContext);
};

const LoadingProvider = ({ children }: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState(false);

  const show = () => setLoading(true);
  const hide = () => setLoading(false);

  return <LoadingContext.Provider value={{ loading, show, hide }}>{children}</LoadingContext.Provider>;
};

const useLoading = (isLoading: boolean) => {
  const loadingContext = useLoadingContext();
  useEffect(() => {
    if (isLoading) {
      loadingContext.show();
    } else {
      loadingContext.hide();
    }
  }, [isLoading]);
};

export { LoadingProvider, useLoading, useLoadingContext };
